import React from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Users, 
  Building2,
  MessageSquare,
  Wrench,
  Wallet,
  Car,
  Ticket,
  Shield,
  BarChart2,
  Settings, 
  FileText,
  Briefcase,
  Megaphone,
  X
} from 'lucide-react';
import logo from '../../assets/Sankrutilogo.jpeg';
import styles from './SuperadminSidebar.module.css';

const SuperadminSidebar = ({ isOpen, onClose }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userInfo');
    navigate('/login');
  };

  const mainItems = [
    { path: '/superadmin', icon: <LayoutDashboard size={18} />, label: 'Dashboard' }
  ];

  const businessItems = [
    { path: '/superadmin/businesses', icon: <Briefcase size={18} />, label: 'Businesses' },
    { path: '/superadmin/business-promo-requests', icon: <Megaphone size={18} />, label: 'Promo Requests' }
  ];

  const societyItems = [
    { path: '/superadmin/admins', icon: <Users size={18} />, label: 'Admins' },
    { path: '/superadmin/residents', icon: <Users size={18} />, label: 'Residents' },
    { path: '/superadmin/visitors', icon: <Users size={18} />, label: 'Visitors' },
    { path: '/superadmin/vehicles', icon: <Car size={18} />, label: 'Vehicles' },
    { path: '/superadmin/gate-passes', icon: <Ticket size={18} />, label: 'Gate Passes' },
    { path: '/superadmin/security-staff', icon: <Shield size={18} />, label: 'Security Staff' },
    { path: '/superadmin/security-logs', icon: <Shield size={18} />, label: 'Security Logs' },
    { path: '/superadmin/complaints', icon: <MessageSquare size={18} />, label: 'Complaints' },
    { path: '/superadmin/maintenance', icon: <Wrench size={18} />, label: 'Maintenance' },
    { path: '/superadmin/payments', icon: <Wallet size={18} />, label: 'Payments & Billing' },
    { path: '/superadmin/amenities', icon: <Building2 size={18} />, label: 'Amenities' },
  ];

  const communityItems = [
    { path: '/superadmin/committee', icon: <Users size={18} />, label: 'Committee' },
    { path: '/superadmin/events', icon: <LayoutDashboard size={18} />, label: 'Events' },
    { path: '/superadmin/notices', icon: <FileText size={18} />, label: 'Notices' },
    { path: '/superadmin/polls', icon: <BarChart2 size={18} />, label: 'Polls' },
    { path: '/superadmin/gallery', icon: <FileText size={18} />, label: 'Gallery' },
    { path: '/superadmin/suggestions', icon: <MessageSquare size={18} />, label: 'Suggestions' },
  ];

  const resourceItems = [
    { path: '/superadmin/documents', icon: <FileText size={18} />, label: 'Documents' },
    { path: '/superadmin/reports', icon: <BarChart2 size={18} />, label: 'Reports & Analytics' }
  ];

  const systemConfigItems = [
    { path: '/superadmin/settings', icon: <Settings size={18} />, label: 'Settings' },
    { path: '/superadmin/audit-logs', icon: <FileText size={18} />, label: 'Audit Logs' }
  ];

  const allGroups = [
    { title: 'MAIN', items: mainItems },
    { title: 'SOCIETY MANAGEMENT', items: societyItems },
    { title: 'BUSINESS MANAGEMENT', items: businessItems },
    { title: 'COMMUNITY', items: communityItems },
    { title: 'RESOURCES', items: resourceItems },
    { title: 'SYSTEM CONFIG', items: systemConfigItems }
  ];

  return (
    <>
      {isOpen && <div className={styles.overlay} onClick={onClose}></div>}
      <aside className={`${styles.sidebar} ${isOpen ? styles.open : ''}`} style={{ overflowY: 'auto' }}>
        <div className={styles.sidebarHeader}>
          <div className={styles.logoArea} onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
            <img 
              src={logo} 
              alt="Sanskruti Shubhaangan" 
              className={styles.logoImage} 
            />
          </div>
          <button className={styles.closeBtn} onClick={onClose}>
            <X size={24} />
          </button>
        </div>

        <nav className={styles.sidebarNav}>
          {allGroups.map((group, idx) => (
            <div key={idx} className={styles.navSection}>
              <p className={styles.sectionTitle}>{group.title}</p>
              {group.items.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  className={({ isActive }) => 
                    `${styles.navItem} ${isActive || (item.path === '/superadmin' && location.pathname === '/superadmin') ? styles.active : ''}`
                  }
                  onClick={onClose}
                  end={item.path === '/superadmin'}
                >
                  {item.icon}
                  <span>{item.label}</span>
                </NavLink>
              ))}
            </div>
          ))}
        </nav>
      </aside>
    </>
  );
};

export default SuperadminSidebar;
